export default __webpack_public_path__ + "static/cn-a7b3251801e98dacfea3426cd885acc4.svg";